(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require(undefined));
	else if(typeof define === 'function' && define.amd)
		define(["plesk-ui-library"], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory(require(undefined));
	else
		root["Jsw"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 164);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** external {"amd":"plesk-ui-library"} ***!
  \*******************************************/
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 105:
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./app/cookie-policy/urls.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var PLESK_COOKIES = exports.PLESK_COOKIES = 'https://docs.plesk.com/en-US/obsidian/cookies';
var CONTROL_COOKIES = exports.CONTROL_COOKIES = 'https://docs.plesk.com/en-US/obsidian/delete-cookies';

/***/ }),

/***/ 111:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./app/cookie-policy/CookiePolicy.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.togglePreferences = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _propTypes = __webpack_require__(/*! prop-types */ 2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Info = __webpack_require__(/*! ./Info */ 158);

var _Info2 = _interopRequireDefault(_Info);

var _Preferences = __webpack_require__(/*! ./Preferences */ 163);

var _Preferences2 = _interopRequireDefault(_Preferences);

var _storage = __webpack_require__(/*! ./storage */ 65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var emitter = {
    listeners: [],

    on: function on(listener) {
        this.listeners.push(listener);
    },
    off: function off(listener) {
        this.listeners = this.listeners.filter(function (l) {
            return l !== listener;
        });
    },
    emit: function emit(flag) {
        this.listeners.forEach(function (listener) {
            listener(flag);
        });
    }
};

var togglePreferences = exports.togglePreferences = function togglePreferences(flag) {
    emitter.emit(flag);
};

var COOKIE_POLICY_PREFERENCES_TOGGLE_SELECTOR = '[data-type="cookie-policy-preferences-toggle"]';

var subscribe = function subscribe(listener) {
    [].concat(_toConsumableArray(document.querySelectorAll(COOKIE_POLICY_PREFERENCES_TOGGLE_SELECTOR))).forEach(function (element) {
        element.addEventListener('click', listener);
    });
    emitter.on(listener);
};

var unsubscribe = function unsubscribe(listener) {
    [].concat(_toConsumableArray(document.querySelectorAll(COOKIE_POLICY_PREFERENCES_TOGGLE_SELECTOR))).forEach(function (element) {
        element.removeEventListener('click', listener);
    });
    emitter.off(listener);
};

var CookiePolicy = function (_Component) {
    _inherits(CookiePolicy, _Component);

    function CookiePolicy() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CookiePolicy);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CookiePolicy.__proto__ || Object.getPrototypeOf(CookiePolicy)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isInfoVisible: !(0, _storage.hasPreferences)(),
            isPreferencesVisible: false
        }, _this.handleSave = function (preferences) {
            _this.setState({ isInfoVisible: false }, function () {
                var event = document.createEvent('HTMLEvents');
                event.initEvent('resize', true, false);
                document.dispatchEvent(event);
            });
            (0, _storage.savePreferences)(preferences);
            new Ajax.Request(Jsw.prepareUrl('/admin/gdpr/update'), {
                method: 'post',
                postBody: JSON.stringify(preferences)
            });
        }, _this.handlePreferencesToggle = function (isPreferencesVisible) {
            _this.setState({ isPreferencesVisible: isPreferencesVisible });
        }, _this.handleExternalToggle = function () {
            _this.handlePreferencesToggle(true);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CookiePolicy, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            subscribe(this.handleExternalToggle);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            unsubscribe(this.handleExternalToggle);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                layoutType = _props.layoutType,
                isInfoEnabled = _props.isInfoEnabled;
            var _state = this.state,
                isInfoVisible = _state.isInfoVisible,
                isPreferencesVisible = _state.isPreferencesVisible;

            var preferences = (0, _storage.loadPreferences)();

            return (0, _uiLibrary.createElement)(
                _uiLibrary.Fragment,
                null,
                isInfoEnabled && isInfoVisible && (0, _uiLibrary.createElement)(_Info2.default, {
                    onSave: this.handleSave,
                    onPreferencesToggle: this.handlePreferencesToggle,
                    contentAlignment: layoutType === 'simplified' ? 'center' : undefined
                }),
                (0, _uiLibrary.createElement)(_Preferences2.default, {
                    isOpen: isPreferencesVisible,
                    preferences: preferences,
                    onSave: this.handleSave,
                    onToggle: this.handlePreferencesToggle,
                    adapter: layoutType === 'simplified' ? _Preferences.OverlayAdapter : undefined
                })
            );
        }
    }]);

    return CookiePolicy;
}(_uiLibrary.Component);

CookiePolicy.propTypes = {
    isInfoEnabled: _propTypes2.default.bool.isRequired,
    layoutType: _propTypes2.default.oneOf(['simplified'])
};

CookiePolicy.defaultProps = {
    layoutType: undefined
};

exports.default = CookiePolicy;

/***/ }),

/***/ 158:
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./app/cookie-policy/Info.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _classnames = __webpack_require__(/*! classnames */ 70);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(/*! prop-types */ 2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _urls = __webpack_require__(/*! ./urls */ 105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var Info = function (_Component) {
    _inherits(Info, _Component);

    function Info() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Info);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Info.__proto__ || Object.getPrototypeOf(Info)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isReady: false
        }, _this.handleAcceptClick = function () {
            var _this$props = _this.props,
                onSave = _this$props.onSave,
                onPreferencesToggle = _this$props.onPreferencesToggle;

            onSave({ analytics: true, marketing: true });
            onPreferencesToggle(false);
        }, _this.handlePreferencesClick = function () {
            var onPreferencesToggle = _this.props.onPreferencesToggle;

            onPreferencesToggle(true);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Info, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                _this2.setState({ isReady: true });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var contentAlignment = this.props.contentAlignment;
            var isReady = this.state.isReady;

            var namespace = 'info';

            return (0, _uiLibrary.createElement)(
                'div',
                {
                    className: (0, _classnames2.default)('cookie-policy-info', _defineProperty({
                        'cookie-policy-info--enter': isReady
                    }, 'cookie-policy-info--' + contentAlignment, contentAlignment))
                },
                (0, _uiLibrary.createElement)(
                    'div',
                    { className: 'cookie-policy-info__inner' },
                    (0, _uiLibrary.createElement)(
                        'h3',
                        { className: 'cookie-policy-info__title' },
                        (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: namespace + '.title' })
                    ),
                    (0, _uiLibrary.createElement)(
                        _uiLibrary.Paragraph,
                        null,
                        (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: namespace + '.necessaryCookiesMessage' })
                    ),
                    (0, _uiLibrary.createElement)(
                        _uiLibrary.Paragraph,
                        null,
                        (0, _uiLibrary.createElement)(_uiLibrary.Translate, {
                            content: namespace + '.message',
                            params: {
                                cookieInformationLink: (0, _uiLibrary.createElement)(
                                    'a',
                                    {
                                        href: _urls.PLESK_COOKIES,
                                        target: '_blank',
                                        rel: 'noopener noreferrer',
                                        className: 'cookie-policy-info__link'
                                    },
                                    (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: namespace + '.cookieInformationLink' })
                                )
                            }
                        })
                    ),
                    (0, _uiLibrary.createElement)(
                        'div',
                        { className: 'cookie-policy-info__buttons' },
                        (0, _uiLibrary.createElement)(
                            _uiLibrary.Button,
                            {
                                className: 'cookie-policy-info__button',
                                'data-type': 'cookie-policy-info-accept-button',
                                onClick: this.handleAcceptClick
                            },
                            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: namespace + '.acceptButton' })
                        ),
                        (0, _uiLibrary.createElement)(
                            _uiLibrary.Button,
                            {
                                className: 'cookie-policy-info__button',
                                'data-type': 'cookie-policy-info-preferences-button',
                                onClick: this.handlePreferencesClick
                            },
                            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: namespace + '.preferencesButton' })
                        )
                    )
                )
            );
        }
    }]);

    return Info;
}(_uiLibrary.Component);

Info.propTypes = {
    onSave: _propTypes2.default.func.isRequired,
    onPreferencesToggle: _propTypes2.default.func.isRequired,
    contentAlignment: _propTypes2.default.oneOf(['center'])
};

Info.defaultProps = {
    contentAlignment: undefined
};

exports.default = Info;

/***/ }),

/***/ 159:
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./app/cookie-policy/Preferences/DrawerAdapter.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(/*! react */ 3);

var _propTypes = __webpack_require__(/*! prop-types */ 2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DrawerAdapter = function DrawerAdapter(_ref) {
    var isOpen = _ref.isOpen,
        onSubmit = _ref.onSubmit,
        onCancel = _ref.onCancel,
        submitButton = _ref.submitButton,
        cancelButton = _ref.cancelButton,
        title = _ref.title,
        children = _ref.children,
        values = _ref.values;
    return (0, _react.createElement)(
        _uiLibrary.Drawer,
        {
            isOpen: isOpen,
            onClose: onCancel,
            'data-type': 'cookie-policy-preferences',
            title: title,
            size: 'sm',
            form: {
                vertical: true,
                onSubmit: onSubmit,
                onCancel: onCancel,
                applyButton: false,
                submitButton: submitButton,
                cancelButton: cancelButton,
                values: values,
                requiredMark: false
            }
        },
        children
    );
}; // Copyright 1999-2020. Plesk International GmbH. All rights reserved.

DrawerAdapter.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    submitButton: _propTypes2.default.shape({
        children: _propTypes2.default.node.isRequired
    }).isRequired,
    cancelButton: _propTypes2.default.shape({
        children: _propTypes2.default.node.isRequired,
        onClick: _propTypes2.default.func.isRequired
    }).isRequired,
    title: _propTypes2.default.node.isRequired,
    children: _propTypes2.default.node.isRequired,
    values: _propTypes2.default.object.isRequired
};

exports.default = DrawerAdapter;

/***/ }),

/***/ 160:
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./app/cookie-policy/Preferences/Overlay.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(/*! react */ 3);

var _reactDom = __webpack_require__(/*! react-dom */ 3);

var _propTypes = __webpack_require__(/*! prop-types */ 2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(/*! classnames */ 70);

var _classnames2 = _interopRequireDefault(_classnames);

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var hasScroll = function hasScroll() {
    return document.documentElement.style.position !== 'fixed';
};

var disableScroll = function disableScroll() {
    if (hasScroll()) {
        (0, _uiLibrary.disableDocumentScroll)();
    }
};

var enableScroll = function enableScroll() {
    if (!hasScroll()) {
        (0, _uiLibrary.enableDocumentScroll)();
    }
};

var Overlay = function (_Component) {
    _inherits(Overlay, _Component);

    function Overlay() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Overlay);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isReady: false
        }, _this.clearAllTimeouts = function () {
            clearTimeout(_this.readyTimeout);
            clearTimeout(_this.enterTimeout);
            clearTimeout(_this.exitTimeout);
        }, _this.readyTimeout = null, _this.enterTimeout = null, _this.exitTimeout = null, _this.handleKeydown = function (e) {
            var onCancel = _this.props.onCancel;

            if (e.keyCode === 27) {
                onCancel();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Overlay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.handleKeydown);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _this2 = this;

            var isOpen = this.props.isOpen;


            if (!prevProps.isOpen && isOpen) {
                this.clearAllTimeouts();
                this.readyTimeout = setTimeout(function () {
                    _this2.setState({
                        isReady: true
                    });
                    _this2.enterTimeout = setTimeout(function () {
                        disableScroll();
                    }, 500);
                }, 100);
            } else if (prevProps.isOpen && !isOpen) {
                this.clearAllTimeouts();
                this.exitTimeout = setTimeout(function () {
                    _this2.setState({ isReady: false });
                    enableScroll();
                }, 500);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearAllTimeouts();
            enableScroll();
            document.removeEventListener('keydown', this.handleKeydown);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isOpen = _props.isOpen,
                onCancel = _props.onCancel,
                children = _props.children;
            var isReady = this.state.isReady;


            if (!isOpen && !isReady) {
                return null;
            }

            return (0, _reactDom.createPortal)((0, _react.createElement)(
                'div',
                {
                    className: (0, _classnames2.default)('cookie-policy-overlay', {
                        'cookie-policy-overlay--enter': isOpen && isReady,
                        'cookie-policy-overlay--exit': !isOpen && isReady
                    })
                },
                (0, _react.createElement)(
                    'div',
                    { className: 'cookie-policy-overlay__modal' },
                    (0, _react.createElement)(
                        'a',
                        { onClick: onCancel, className: 'cookie-policy-overlay__modal-close' },
                        (0, _react.createElement)(_uiLibrary.Icon, { name: 'cross-mark' })
                    ),
                    (0, _react.createElement)(
                        'div',
                        { className: 'cookie-policy-overlay__modal-content' },
                        (0, _react.createElement)(
                            'div',
                            { className: 'cookie-policy-overlay__modal-inner' },
                            children
                        )
                    )
                )
            ), document.body);
        }
    }]);

    return Overlay;
}(_react.Component);

Overlay.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.node.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

exports.default = Overlay;

/***/ }),

/***/ 161:
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./app/cookie-policy/Preferences/OverlayAdapter.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(/*! react */ 3);

var _propTypes = __webpack_require__(/*! prop-types */ 2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _Overlay = __webpack_require__(/*! ./Overlay */ 160);

var _Overlay2 = _interopRequireDefault(_Overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var OverlayAdapter = function OverlayAdapter(_ref) {
    var isOpen = _ref.isOpen,
        onSubmit = _ref.onSubmit,
        onCancel = _ref.onCancel,
        submitButton = _ref.submitButton,
        cancelButton = _ref.cancelButton,
        title = _ref.title,
        children = _ref.children,
        values = _ref.values;
    return (0, _react.createElement)(
        _Overlay2.default,
        { isOpen: isOpen, onCancel: onCancel },
        (0, _react.createElement)(
            _uiLibrary.Form,
            {
                vertical: true,
                onSubmit: onSubmit,
                onCancel: onCancel,
                applyButton: false,
                submitButton: submitButton,
                cancelButton: cancelButton,
                values: values,
                requiredMark: false
            },
            (0, _react.createElement)(
                'h1',
                { className: 'cookie-policy-preferences__title' },
                title
            ),
            children
        )
    );
};

OverlayAdapter.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    submitButton: _propTypes2.default.shape({
        children: _propTypes2.default.node.isRequired
    }).isRequired,
    cancelButton: _propTypes2.default.shape({
        children: _propTypes2.default.node.isRequired,
        onClick: _propTypes2.default.func.isRequired
    }).isRequired,
    title: _propTypes2.default.node.isRequired,
    children: _propTypes2.default.node.isRequired,
    values: _propTypes2.default.object.isRequired
};

exports.default = OverlayAdapter;

/***/ }),

/***/ 162:
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./app/cookie-policy/Preferences/Preferences.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(/*! react */ 3);

var _propTypes = __webpack_require__(/*! prop-types */ 2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _DrawerAdapter = __webpack_require__(/*! ./DrawerAdapter */ 159);

var _DrawerAdapter2 = _interopRequireDefault(_DrawerAdapter);

var _urls = __webpack_require__(/*! ../urls */ 105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toValues = function toValues(preferences) {
    return Object.keys(preferences).reduce(function (acc, k) {
        acc[k] = preferences[k] ? 'on' : 'off';
        return acc;
    }, {});
}; // Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var toPreferences = function toPreferences(values) {
    return Object.keys(values).reduce(function (acc, k) {
        acc[k] = values[k] === 'on';
        return acc;
    }, {});
};

var Preferences = function Preferences(_ref) {
    var isOpen = _ref.isOpen,
        onSave = _ref.onSave,
        onToggle = _ref.onToggle,
        preferences = _ref.preferences,
        _ref$adapter = _ref.adapter,
        Adapter = _ref$adapter === undefined ? _DrawerAdapter2.default : _ref$adapter;

    var namespace = 'preferences';

    var handleSubmit = function handleSubmit(values) {
        onSave(toPreferences(values));
        onToggle(false);
    };

    var handleCancel = function handleCancel() {
        return onToggle(false);
    };
    var values = toValues(preferences);

    return (0, _react.createElement)(
        Adapter,
        {
            isOpen: isOpen,
            title: (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.title' }),
            submitButton: {
                children: (0, _react.createElement)(_uiLibrary.Translate, {
                    content: namespace + '.submitButton',
                    'data-type': 'cookie-policy-preferences-submit-button'
                })
            },
            cancelButton: {
                children: (0, _react.createElement)(_uiLibrary.Translate, {
                    content: namespace + '.cancelButton',
                    'data-type': 'cookie-policy-preferences-cancel-button'
                }),
                onClick: handleCancel
            },
            values: values,
            onSubmit: handleSubmit,
            onCancel: handleCancel
        },
        (0, _react.createElement)(
            _uiLibrary.Paragraph,
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.description' })
        ),
        (0, _react.createElement)(
            'h2',
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.settingsTitle' })
        ),
        (0, _react.createElement)(
            _uiLibrary.Paragraph,
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.settingsDescription' })
        ),
        (0, _react.createElement)(
            'h3',
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.analyticsTitle' })
        ),
        (0, _react.createElement)(
            _uiLibrary.Paragraph,
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.analyticsDescription' })
        ),
        (0, _react.createElement)(_uiLibrary.FormFieldRadioButtons, {
            name: 'analytics',
            value: values.analytics,
            className: 'cookie-policy-preferences__radio-buttons',
            options: [{
                value: 'on',
                label: (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.on' })
            }, {
                value: 'off',
                label: (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.off' })
            }]
        }),
        (0, _react.createElement)(
            'h3',
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.marketingTitle' })
        ),
        (0, _react.createElement)(
            _uiLibrary.Paragraph,
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.marketingDescription' })
        ),
        (0, _react.createElement)(_uiLibrary.FormFieldRadioButtons, {
            name: 'marketing',
            value: values.marketing,
            className: 'cookie-policy-preferences__radio-buttons',
            options: [{
                value: 'on',
                label: (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.on' })
            }, {
                value: 'off',
                label: (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.off' })
            }]
        }),
        (0, _react.createElement)(
            'h3',
            null,
            (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.necessaryTitle' })
        ),
        (0, _react.createElement)(
            _uiLibrary.Paragraph,
            null,
            (0, _react.createElement)(_uiLibrary.Translate, {
                content: namespace + '.necessaryDescription',
                params: {
                    browserSettingsLink: (0, _react.createElement)(
                        'a',
                        { href: _urls.CONTROL_COOKIES, target: '_blank', rel: 'noopener noreferrer' },
                        (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.browserSettingsLink' })
                    )
                }
            })
        ),
        (0, _react.createElement)(
            _uiLibrary.Paragraph,
            null,
            (0, _react.createElement)(
                'a',
                { href: _urls.PLESK_COOKIES, target: '_blank', rel: 'noopener noreferrer' },
                (0, _react.createElement)(_uiLibrary.Translate, { content: namespace + '.pleskCookiesLink' })
            )
        )
    );
};

Preferences.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    onSave: _propTypes2.default.func.isRequired,
    onToggle: _propTypes2.default.func.isRequired,
    preferences: _propTypes2.default.object.isRequired,
    adapter: _propTypes2.default.func
};

Preferences.defaultProps = {
    adapter: undefined
};

exports.default = Preferences;

/***/ }),

/***/ 163:
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./app/cookie-policy/Preferences/index.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Preferences = __webpack_require__(/*! ./Preferences */ 162);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Preferences).default;
  }
});

var _OverlayAdapter = __webpack_require__(/*! ./OverlayAdapter */ 161);

Object.defineProperty(exports, 'OverlayAdapter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayAdapter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 164:
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./app/cookie-policy/index.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _CookiePolicy = __webpack_require__(/*! ./CookiePolicy */ 111);

var _CookiePolicy2 = _interopRequireDefault(_CookiePolicy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2020. Plesk International GmbH. All rights reserved.

module.exports = {
    default: function _default(_ref) {
        var container = _ref.container,
            locale = _ref.locale,
            props = _objectWithoutProperties(_ref, ['container', 'locale']);

        (0, _uiLibrary.render)((0, _uiLibrary.createElement)(
            _uiLibrary.LocaleProvider,
            { messages: locale },
            (0, _uiLibrary.createElement)(_CookiePolicy2.default, props)
        ), container);
    },
    togglePreferences: _CookiePolicy.togglePreferences
};

/***/ }),

/***/ 2:
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** /home/builder/buildbot/microupdate/PLESK_17_8/build/buck-out/gen/~/node_modules/prop-types/index.js ***!
  \***********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(/*! ./factoryWithThrowingShims */ 28)();
}


/***/ }),

/***/ 26:
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************!*\
  !*** /home/builder/buildbot/microupdate/PLESK_17_8/build/buck-out/gen/~/node_modules/fbjs/lib/emptyFunction.js ***!
  \*****************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ 27:
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** /home/builder/buildbot/microupdate/PLESK_17_8/build/buck-out/gen/~/node_modules/fbjs/lib/invariant.js ***!
  \*************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 28:
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************!*\
  !*** /home/builder/buildbot/microupdate/PLESK_17_8/build/buck-out/gen/~/node_modules/prop-types/factoryWithThrowingShims.js ***!
  \******************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(/*! fbjs/lib/emptyFunction */ 26);
var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 27);
var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ 29);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 29:
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************!*\
  !*** /home/builder/buildbot/microupdate/PLESK_17_8/build/buck-out/gen/~/node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \******************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 3:
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** ../react-compat.js ***!
  \**************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plesk_ui_library__ = __webpack_require__(/*! @plesk/ui-library */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plesk_ui_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plesk_ui_library__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__plesk_ui_library__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__plesk_ui_library__[key]; }) }(__WEBPACK_IMPORT_KEY__));
// Copyright 1999-2017. Plesk International GmbH. All rights reserved.



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__plesk_ui_library__);



/***/ }),

/***/ 65:
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./app/cookie-policy/storage.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

var COOKIE_POLICY_LOCAL_STORAGE_KEY = 'cookie-policy';

var hasPreferences = exports.hasPreferences = function hasPreferences() {
    return !!localStorage.getItem(COOKIE_POLICY_LOCAL_STORAGE_KEY);
};

var savePreferences = exports.savePreferences = function savePreferences(preferences) {
    localStorage.setItem(COOKIE_POLICY_LOCAL_STORAGE_KEY, JSON.stringify(preferences));
};

var loadPreferences = exports.loadPreferences = function loadPreferences() {
    var analytics = false;
    var marketing = false;
    try {
        var data = JSON.parse(localStorage.getItem(COOKIE_POLICY_LOCAL_STORAGE_KEY));
        if (typeof data.analytics === 'boolean') {
            analytics = data.analytics;
        }
        if (typeof data.marketing === 'boolean') {
            marketing = data.marketing;
        }
    } catch (e) {}
    return {
        analytics: analytics,
        marketing: marketing
    };
};

var isAnalyticsAllowed = exports.isAnalyticsAllowed = function isAnalyticsAllowed() {
    return loadPreferences().analytics;
};

/***/ }),

/***/ 70:
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** /home/builder/buildbot/microupdate/PLESK_17_8/build/buck-out/gen/~/node_modules/classnames/index.js ***!
  \***********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/cookie-policy.js